import { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("usuario");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUsuario(parsedUser);
      } catch (e) {
        console.error("Error al parsear usuario desde localStorage:", e);
        localStorage.removeItem("usuario");
      }
    } else {
    }
    setLoading(false);
  }, []);

  const login = (userData, token, refreshToken) => {
    setUsuario(userData);
    localStorage.setItem("usuario", JSON.stringify(userData));
    localStorage.setItem("token", token);
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('empresaSeleccionada');
    setUsuario(null);
    navigate('/login');
  };

  const isAdmin = () => {
    return usuario?.rol === 'conexadmin';
  };

  const isEmpresaAdmin = () => {
    return usuario?.rol === 'administrador';
  };

  const canCreateUsers = () => {
    return isAdmin() || isEmpresaAdmin();
  };

  const canCreateEmpresas = () => {
    return isAdmin();
  };

  const canCreateAdmins = () => {
    return isAdmin();
  };

  return (
    <AuthContext.Provider value={{ 
      usuario, 
      login, 
      logout, 
      loading,
      isAdmin,
      isEmpresaAdmin,
      canCreateUsers,
      canCreateEmpresas,
      canCreateAdmins
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe usarse dentro de un AuthProvider");
  }
  return context;
};
